import { call, put, select } from 'redux-saga/effects';

import UserClient from '../../api/UserClient';
import {
    getInvoicesReplayDataSuccess,
    getInvoicesReplayDataFailure,
    setIsPaymentProcessing,
    setInvoicesReplayProvider,
} from '../../redux/invoicesReplay/actions';
import { messagesShow } from '../../redux/messages/actions';
import { isPaymentProcessingSelector } from '../../selectors/invoicesReplay';

export function* getInvoicesReplayDataSaga() {
    // /paymentOptions carries the PSP as the section name: `stripe` or `adyen`.
    let replayData = {};
    try {
        const invoicesReplayList = yield call(UserClient.getInvoicesReplayList);

        const { adyen, stripe } = invoicesReplayList;
        const provider = (adyen && 'ADYEN') || (stripe && 'STRIPE') || null;
        replayData = adyen || stripe || {};
        // Provider first: these are two dispatches, so a render can happen in
        // between, and a null provider there renders the Stripe branch.
        yield put(setInvoicesReplayProvider(provider));
        yield put(getInvoicesReplayDataSuccess(replayData));

        const isPaymentProcessing = yield select(isPaymentProcessingSelector);
        if (isPaymentProcessing) {
            yield put(setIsPaymentProcessing(false));
        }

        return replayData;
    } catch (error) {
        yield put(getInvoicesReplayDataFailure());
        const errorMsg = error.message && typeof error.message === 'string' ? error.message : 'internalServerError';
        yield put(messagesShow(errorMsg, 'error'));
    }
    return replayData;
}
